/**
 * Top-level Profit sidebar tab — historical analysis.
 * Everyone sees live truth (Xero company KPIs when ingested; otherwise ops
 * attribution). Demo fixtures are an admin-only toggle behind the gear.
 */

import { useState } from 'react';
import ProfitSection from '../components/fleetDataHub/ProfitSection';
import { isSessionAdmin } from '../utils/pageAccess';

export default function OpsProfit() {
  const isAdmin = isSessionAdmin();
  const [useMockData, setUseMockData] = useState(false);

  return (
    <ProfitSection
      // Non-admins can never be in demo mode.
      demoMode={isAdmin && useMockData}
      onDemoModeChange={isAdmin ? setUseMockData : undefined}
      showDemoGear={isAdmin}
      isAdmin={isAdmin}
    />
  );
}
